export default "__VITE_ASSET__26bcbb1a__"